(() => {
 if(window.LaRosaDeliveryDates) return;
    function getEaster(year) {
      const a = year % 19, b = Math.floor(year / 100), c = year % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(year, month, day);
    }

    function getBayernHolidays(year) {
      const easter = getEaster(year);
      const e = (offset) => { const d = new Date(easter); d.setDate(d.getDate() + offset); return d; };
      const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      return new Set([
        `${year}-01-01`, // Neujahr
        `${year}-01-06`, // Heilige Drei Könige
        fmt(e(-2)),      // Karfreitag
        fmt(e(1)),       // Ostermontag
        `${year}-05-01`, // Tag der Arbeit
        fmt(e(39)),      // Christi Himmelfahrt
        fmt(e(50)),      // Pfingstmontag
        fmt(e(60)),      // Fronleichnam
        `${year}-08-15`, // Mariä Himmelfahrt
        `${year}-10-03`, // Tag der Deutschen Einheit
        `${year}-11-01`, // Allerheiligen
        `${year}-12-25`, // 1. Weihnachtstag
        `${year}-12-26`, // 2. Weihnachtstag
      ]);
    }

    function isHolidayOrSunday(date) {
      const year = date.getFullYear();
      const holidays = getBayernHolidays(year);
      const fmt = `${year}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
      return date.getDay() === 0 || holidays.has(fmt);
    }

    function skipNonDelivery(date) {
      while (isHolidayOrSunday(date)) {
        date.setDate(date.getDate() + 1);
      }
      return date;
    }


function lrFulfillmentBase(now = new Date()) {
 const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
 const base = new Date(Number(parts.year), Number(parts.month)-1, Number(parts.day), 12);
 if (Number(parts.hour) >= 12) base.setDate(base.getDate()+1);
 while (base.getDay() === 6 || isHolidayOrSunday(base)) base.setDate(base.getDate()+1);
 return base;
}
function lrAddTransitDays(base, days) {
 const date = new Date(base);
 for(let counted=0; counted<days;) {
  date.setDate(date.getDate()+1);
  if(date.getDay()!==6 && !isHolidayOrSunday(date)) counted++;
 }
 return date;
}

function deliveryRange(minDays,maxDays,now = new Date()) {
 const fulfillmentDate=lrFulfillmentBase(now),minDate=lrAddTransitDays(fulfillmentDate,minDays),maxDate=lrAddTransitDays(fulfillmentDate,maxDays);
 return minDate.toLocaleDateString('de-DE',{day:'numeric',month:'short'})+'–'+maxDate.toLocaleDateString('de-DE',{day:'numeric',month:'short'});
}

 window.LaRosaDeliveryDates = {formatRange:deliveryRange};
 class LrProductDelivery extends HTMLElement {
  connectedCallback() {
   const timeline = this.querySelector('.shipping-stepper');
   if(!timeline) return;
   const min = Number(timeline.dataset.deliveryMin), max = Number(timeline.dataset.deliveryMax);
   if(![min,max].every(n=>Number.isFinite(n)&&n>=0&&n<=365)||max<min) return;
   const date = timeline.querySelector('.shipping-stepper__date--dynamic');
   if(date) date.textContent = deliveryRange(min,max);
   const duration = timeline.querySelector('[data-transit-duration]');
   if(duration) duration.textContent = (min===max ? min : min+'–'+max) + ' Werktage';
  }
 }
 if(!customElements.get('lr-product-delivery')) customElements.define('lr-product-delivery',LrProductDelivery);
})();
